import React, { useMemo } from 'react';
import { Badge, Button, Table, TableProps } from 'antd';
import ErrorBoundary from '~/App/components/ErrorBoundary';
import { PrinterItem } from '../../types';
import { fetchPrinters } from './api';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

const EditButton = ({ id }: { id: string }) => {
  const navigate = useNavigate();
  return (
    <Button onClick={() => navigate(`edit/${id}`)} type="primary">
      Edit
    </Button>
  );
};

const useColumns = () => {
  return useMemo((): TableProps<PrinterItem>['columns'] => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
      },
      {
        title: 'IP Address',
        dataIndex: 'ipAddress',
      },
      {
        title: 'Status',
        dataIndex: 'isActive',
        render: (val: boolean) => {
          return (
            <Badge
              status={val ? 'processing' : 'default'}
              text={val ? 'Active' : 'Inactive'}
            />
          );
        },
      },
      {
        title: 'Action',
        render: (_, item) => {
          return (
            <div>
              <EditButton id={item.printerId} />
            </div>
          );
        },
      },
    ];
  }, []);
};

const ListPrinterTable = () => {
  const columns = useColumns();
  const { data, isLoading } = useQuery({
    queryKey: ['listPrinter'],
    queryFn: fetchPrinters,
    throwOnError: true,
  });

  return (
    <Table
      columns={columns}
      loading={isLoading}
      dataSource={data?.printers ?? []}
      rowKey="printerId"
    />
  );
};

const ListPrinter = () => {
  const navigate = useNavigate();
  const onClickCreate = () => {
    navigate('create');
  };
  return (
    <div className="p-6">
      <div className="mb-6 flex justify-between items-center">
        <h1 className="text-2xl">Printer</h1>
        <Button type="primary" onClick={onClickCreate}>
          + Create
        </Button>
      </div>
      <ErrorBoundary>
        <ListPrinterTable />
      </ErrorBoundary>
    </div>
  );
};

export default ListPrinter;
